export const LOCATION_LIST = 'LOCATION_LIST'
export const CURRENT_LOCATION = 'CURRENT_LOCATION'


// WEBPACK FOOTER //
// ./src/store/modules/location/constant.js